// Betting Configuration
export const bettingConfig = {
  // Minimum and maximum bet amounts
  minAmount: 1,
  maxAmount: 200,
  
  // Default bet amount
  defaultAmount: 10,
  
  // Validation messages
  // Validation messages live in i18n locale files under `betting.validation`.
  // Use them in components with: $t('betting.validation.required') or
  // $t('betting.validation.minAmount', { min: bettingConfig.minAmount })
}